import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '../Services/authorization/authorization.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { LoginToken } from '../models/loginToken';
// import { HeaderComponent } from '../header/header/header.component';
import { AppComponent } from '../app.component';
import { IUserDetails } from '../models/IUsersDetails';
import { AESAlgorithm } from '../Utilities/Crypto/AESAlgorithm';
import { forkJoin } from 'rxjs';
import { PatientBannerService } from '../patient-banner/patient-banner.service';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { configuration } from 'src/environments/environment';
import { LockService } from '../Services/LockService/lock-service.service';
import { DService, OuterMenu, UserRoleservice } from '../Services/common.service';
import { UserActivationService } from '../Services/Activation/user-activation.service';
import { DatePipe } from '@angular/common';
import { ILocationDetails } from '../models/ILocationDetails';
import { SharedService } from '../Sharedservice/SharedService';
import { DocumentService } from '../Services/Documents/document.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';

declare var $: any;
declare var window: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  LoginForm: FormGroup;
  isfacilityVisible: boolean = false;
  islogin: boolean = false;
  isloginError: boolean = false;
  errorMessage: string;
  static userid: any;
  userdetails: IUserDetails;
  tokenstarttime: any;
  tokenendtime: any;
  facilityList: any;
  facilityListMulti: any;
  // 
  ClientIpAddress: string = "";
  ClientIpJSON: string = "";
  IsMailRequestSent: boolean = false;
  MessageType: string = "email";
  IPAddressExists = true;
  defaultFacilityId: any;
  SelectedFacilityId: number = 0;
  ShowSelectedFacilities: boolean = false;
  facilityListMaster: any = [];
  IsDisableSignIn: boolean = false;
  CheckOTPExists: Boolean = false;
  Send_ReSendOTP: string = "Send OTP";
  IsRegisterActivationLink: boolean = configuration.IsRegisterActivationLink;
  constructor(private fb: FormBuilder,
    private router: Router
    , private crypto: AESAlgorithm
    , private authService: AuthorizationService
    , private app: AppComponent,
    private bannerService: PatientBannerService
    , private cookieService: CookieService
    , private toast: ToastrService
    , private lockService: LockService
    , smallmenu: DService
    , private activation: UserActivationService,
    private datePipe: DatePipe,
    private _documentService: DocumentService,
    private _userRoleservice: UserRoleservice
    , private spinner: NgxSpinnerService,
    private sharedService: SharedService, private formBuilder: FormBuilder, private httpClient: HttpClient) {
    this.app.dproducts = smallmenu.getProducts();
    if (sessionStorage.getItem("role") === 'Admin' || sessionStorage.getItem("role") === "Clerk") {
      this.app.dproducts = this.app.dproducts.filter(a => a.Name !== 'Settings')
    } else {
      this.app.dproducts = smallmenu.getProducts();
    }
    //  alert("login");
    this.activation.getClientFacilitiies().subscribe(async data => {
      this.facilityList = data;
      await this.facilityList;
      this.facilityListMulti = data;
      //alert(this.IsRegisterActivationLink)

      if (this.IsRegisterActivationLink == true) {
        if (this.cookieService.get('MD4FacilityId').length != 0) {
          //var facilities = this.cookieService.get('MD4FacilityId');
          var facilities = decodeURIComponent(this.cookieService.get('MD4FacilityId'));
          if (facilities.includes(',')) {
            if (this.facilityList != null && this.facilityList.length > 0) {
              this.facilityList = this.facilityList.filter(c => facilities.includes(c.facilityId));
            }
          }
        }
      }


    });
    if (this.IsRegisterActivationLink == true) {
      if (this.cookieService.get('MD4FacilityId').length != 0) {
        var facilities = this.cookieService.get('MD4FacilityId');
        if (facilities.includes(',')) {
          if (this.facilityList != null && this.facilityList.length > 0) {
            this.facilityList = this.facilityList.filter(c => facilities.includes(c.facilityId));
          }
          this.isfacilityVisible = true;
          if (sessionStorage.getItem("userId") != null && sessionStorage.getItem("userId") != undefined && sessionStorage.getItem("userId") != '') {
            if (sessionStorage.getItem('FacilityId') != null || sessionStorage.getItem('FacilityId') != undefined || sessionStorage.getItem('FacilityId') != '') {
              this.activation.getFacilityDetailsById(Number(sessionStorage.getItem('FacilityId')), sessionStorage.getItem("userId")).subscribe(results => {
                if (results != null) {
                  configuration.key = results.clientsalt;
                  configuration.iv = results.clientkey;
                }
              },
                (err: any) => console.log(err)
              );
            }
          }
        }
        else {

          sessionStorage.setItem("FacilityId", this.cookieService.get('MD4FacilityId'));
          this.activation.getFacilityDetailsById(Number(this.cookieService.get('MD4FacilityId')), sessionStorage.getItem("userId")).subscribe(results => {
            if (results != null) {

              configuration.key = results.clientsalt;
              configuration.iv = results.clientkey;
            }
          }
            ,
            (err: any) => console.log(err)
          );
          if (sessionStorage.getItem("userId") != null && sessionStorage.getItem("userId") != undefined && sessionStorage.getItem("userId") != '') {

            this.router.navigateByUrl('/Appointments');
          }
          else {
            //alert("1");
            localStorage.removeItem('usertoken');
            localStorage.removeItem('role');
            localStorage.removeItem('clinictoken');
            // localStorage.removeItem('billingToken');
            sessionStorage.removeItem('usertoken');
            sessionStorage.removeItem('clinictoken');
            localStorage.removeItem('TokenStartTime');
            localStorage.removeItem('TokenEndTime');
          }
        }

      }
      else {
        if (sessionStorage.getItem("RegId") != null || sessionStorage.getItem("RegId") != undefined || sessionStorage.getItem("RegId") != '') {
          this.router.navigateByUrl('/Register');
        }
      }
    }
  }
  public todayDate = new Date();
  ipAddressStatus: string = "";
  ngOnInit() {
    this.LoginForm = this.fb.group({
      Password: [''],
      OTP:['']
    })
    var visitDate: any = this.datePipe.transform(this.todayDate, 'MM/dd/yyyy')
    sessionStorage.setItem("appDate", visitDate);
    this.bannerService.hide(false);
    //this.getmainMenuList();
    if (this.IsRegisterActivationLink == false) {
      sessionStorage.setItem('FacilityId', '0');


      this.activation.getClientIpAddress().subscribe((result: any) => {
        if (result) {
          this.ClientIpAddress =  (result).ip;
          ///alert( this.ClientIpAddress)
          this.activation.getFacilityByIPAddress(this.ClientIpAddress).subscribe((result: any) => {
            this.ipAddressStatus = result;
          })
        }
      })
    }
    //this.fnGetIPFacilities();
  }
  //** FocusOut for User name */
  onFocusUsename(event) {
    // if (this.IsRegisterActivationLink == false) {
    //   this.isfacilityVisible = false;
    //   this.IPAddressExists = true;
    //   this.IsDisableSignIn = false;
    //   sessionStorage.setItem('FacilityId', '0');
    //   this.LoginForm.patchValue({ Password: '' })
    // }
  }

  //**** onKeyUP UserName */
  onKeyup_UserName(event) {
    if (this.IsRegisterActivationLink == false) {
      this.isfacilityVisible = false;
      this.IPAddressExists = true;
      this.IsDisableSignIn = false;
      sessionStorage.setItem('FacilityId', '0');
      this.LoginForm.patchValue({ Password: '' })
    }
  }

  //*** Enter only Numbers for PhoneNumber and OTP controls */
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    // if (event.keyCode != 50) {
    if (charCode != 13 && (charCode < 47 || charCode > 57)) {
      return false;
    }
    return true;
    //}
  }
  //*** KeyUp event for login Button validation (Enable/Disable) */
  validateOTP: string = "";
  onKeyupEnterOTP(event) {
    this.validateOTP = event.target.value;
    if (this.validateOTP == "") {
      this.IsDisableSignIn = true;
    } else {
      if (this.validateOTP.length == 8) {
        this.IsDisableSignIn = false;
      } else {
        this.IsDisableSignIn = true;
      }
    }
  }
  //*** click On Send OTP Button and Validating the Entered MobileNumber */
  isDisableUserNamePassword:boolean=false;
  onClick_SendOTP(number, userName, password) {
    //sessionStorage.setItem('FacilityId', '0')
    this.LoginForm.patchValue({ OTP: '' })
    this.IsDisableSignIn=true;
    this.spinner.show();
    var mobileNumber = number;
    if (userName == "" || password == "") {
      this.toast.error('Please Enter User Name and Password')
      return false;
    } else {
      if (mobileNumber != "" && mobileNumber != undefined && mobileNumber != null) {
        if (mobileNumber.length == 14) {
          let encryptUserId = encodeURIComponent(this.crypto.encryptor(userName.toLowerCase()).toString());
          
          let encryptUserPswd = password//encodeURIComponent(this.crypto.encryptor(password).toString());
          this.activation.ValidateLoginUser(encryptUserId, encryptUserPswd, this.ClientIpAddress, mobileNumber, userName.toLowerCase(), this.facilityValue).
            subscribe(result => {
              if (result == "Invalid Mobile No") {
                this.toast.error("Entered Phone Number does not match with the User Account")
                this.spinner.hide();
                return false;
              } else if (result == "Invalid Login") {
                this.toast.error('Entered Phone Number does not match with the User Account')
                this.spinner.hide();
                return false;
              } else if (result.status.includes('success')) {
                this.CheckOTPExists = true;
                this.Send_ReSendOTP = "Re-Send OTP";
                this.toast.success('OTP Send to Your Registered Mobile Number.')
                this.spinner.hide();
                this.isDisableUserNamePassword=true;
              } else {
                this.toast.error('Unable to send OTP. Please try again.')
                this.spinner.hide();
                this.IsDisableSignIn = false;
              }
            }
              , error => {
                this.toast.error(error);
              }
            );
        } else {
          this.toast.error('Invalid Phone Number.')
          this.spinner.hide();
        }
      } else {
        this.toast.error('Please Enter Mobile Number.')
        this.spinner.hide();
      }
    }
  }

  //*** validating Received OTP */
  fnReceviceOTP(userName, password, receivedOTP) {
    let encryptUserId = encodeURIComponent(this.crypto.encryptor(userName).toString());
    this.activation.CheckReceivedOTP(encryptUserId, receivedOTP, this.ClientIpAddress).
      subscribe(result => {
        if (result != null && result != undefined && result != "") {
          if (result.includes("Valid")) {
            if (Number(sessionStorage.getItem('FacilityId')) == 0) {
              this.toast.error("No Facility to mapped");
              return false;
            }
            this.toast.success("OTP verified successfully")
            return this.loginAfterValidateOTP(userName, password);
          } else {
            if (Number(sessionStorage.getItem('FacilityId')) == 0) {
              this.toast.error("No Facility to mapped");
              return;
            }
            this.toast.error('InValid OTP')
            return false;
          }
        }
      });
  }
  //*** Main Login button click functionality  */
  login(UserName, password) {
    if (this.IsRegisterActivationLink == true) {
      this.loginAfterValidateOTP(UserName, password);
    } else {
      if (this.CheckOTPExists == true) {
        if (this.validateOTP == "") {
          this.toast.error("Please verify your OTP before login")
          return false;
        } else {
          return this.fnReceviceOTP(UserName, password, this.validateOTP)
        }
      } else {
        if (this.validateOTP == "") {
          if (this.isfacilityVisible == true) {
            this.loginAfterValidateOTP(UserName, password);
          } else
            if (this.IPAddressExists == true) {
              let encryptUserId = this.crypto.encryptor(UserName.toLowerCase()).toString();
              let encryptUserPswd = password//encodeURIComponent(this.crypto.encryptor(password).toString());
              //encryptUserId, encryptUserPswd, this.ClientIpAddress, mobileNumber, userName, this.facilityValue
              this.activation.ValidateLoginUser(encryptUserId, encryptUserPswd, this.ClientIpAddress, "",UserName !="" ? UserName.toLowerCase() : UserName, 0).
                subscribe(result => {
                  if (result == "Invalid Login") {
                    this.toast.error('Invalid User Name or Password')
                    return false;
                  }
                  else if (typeof result === 'string' && result.includes('Access Locked')) {
                    this.toast.error("Your account is locked due to too many failed login attempts. Please contact your Administrator.");
                    this.IsDisableSignIn = true;
                    return false;
                  }
                  else if (typeof result === 'string' && result.includes('Invalid username or password')) {
                    result.split('\n').map(part => part.trim()).filter(part => part).forEach(part => this.toast.error(part));
                    return false;
                  }
                  else if (result.FacilityID.includes('Added')) {
                    if (this.isfacilityVisible == false) {
                      if (result.FacilityID.includes("#")) {
                        var split = result.FacilityID.split("#")[1]
                        if (split.indexOf(",") > -1) {
                          const validIds = split
                                          .split(',')
                                          .map(v => Number(v.trim()))
                                          .filter(v => !isNaN(v));
                          this.facilityList = this.facilityListMulti.filter(c =>
                            validIds.includes(Number(c.facilityId))
                          );

                          //this.SelectedFacilityId = this.facilityList[0].facilityId;
                          this.isfacilityVisible = true;
                        } else {
                          this.facilityList = this.facilityListMulti.filter(c => c.facilityId == split);
                          this.SelectedFacilityId = this.facilityList[0].facilityId;
                          sessionStorage.setItem('FacilityId', this.SelectedFacilityId.toString());
                          //**** */
                          this.activation.getFacilityByIPAddressByUserId(this.ClientIpAddress, "", Number(sessionStorage.getItem('FacilityId'))).subscribe((result: any) => {
                            if (result == null) {
                              this.IPAddressExists = true;
                              this.IsDisableSignIn = true;
                              this.IPAddressExists = false;
                              this.CheckOTPExists = false;
                            } else {
                              if (result.toString().toLowerCase() == "notfound") {
                                this.IPAddressExists = false;
                                this.IsDisableSignIn = true;
                                this.CheckOTPExists = false;

                              } else {
                                this.CheckOTPExists = false;
                                this.IPAddressExists = true;
                                this.IsDisableSignIn = false;
                                this.loginAfterValidateOTP(UserName, password);
                              }
                            }
                          })
                        }
                      }
                    }
                  }
                  else {
                    this.loginAfterValidateOTP(UserName, password);
                  }
                }
                  , error => {
                    
                    this.toast.error("Please Enter User Name and Password");
                  }
                );
            }
        } else {
          let encryptUserId = encodeURIComponent(this.crypto.encryptor(UserName).toString());
          this.activation.CheckOTPTime(encryptUserId, this.validateOTP).
            subscribe(result => {
              if (result != null && result != undefined && result != "") {
                if (result == "Valid Time") {
                  this.toast.success("OTP verified successfully")
                  this.loginAfterValidateOTP(UserName, password);
                } else {
                  this.toast.error('Your OTP is Expired')
                  return false;
                }
              }
            });
        }
        // }

      }
    }

  }
  _window;
  //**** check login validations for IPAdress and Phone number concept */
  loginAfterValidateOTP(UserName, password) {
    localStorage.removeItem("UserPermComp");
    localStorage.removeItem('usertoken');
    localStorage.removeItem('role');
    localStorage.removeItem('clinictoken');
    localStorage.removeItem('billingToken');
    localStorage.removeItem('TokenStartTime');
    localStorage.removeItem('TokenEndTime');
    sessionStorage.removeItem('usertoken');
    sessionStorage.removeItem('clinictoken');
    localStorage.removeItem('ordernoteheaderVisibility');
    sessionStorage.removeItem("EnableEmergencyAccess");
    sessionStorage.removeItem("EmergencyAccessEnabled");
    if (UserName === '' || password === '') {
      this.toast.error("Enter Your UserName and Password");
      return;
    }

    if (Number(sessionStorage.getItem('FacilityId')) == 0) {
      this.toast.error("Select the facility");
      return;
    }
    this.islogin = true;
    this.activation.getFacilityDetailsById(Number(sessionStorage.getItem('FacilityId')), 'admin').subscribe(results => {
      if (results != null) {
        configuration.key = results.clientsalt;
        configuration.iv = results.clientkey;
        var tempUserName = (UserName == "Mahendra" ? UserName : UserName.toLowerCase());
        UserName = this.crypto.encryptor(tempUserName).toString();
        LoginToken.UserId = UserName;
    LoginToken.UserPassword = password;
    localStorage.setItem("gilonidlg", this.crypto.urlParmeterEncoder(UserName + "##" + password));
    sessionStorage.setItem("gilonidlg", this.crypto.urlParmeterEncoder(UserName + "##" + password));
    this.tokenstarttime = sessionStorage.getItem('TokenStartTime');
    this.tokenendtime = sessionStorage.getItem('TokenEndTime');
    let userToken = sessionStorage.getItem('usertoken');;// this.cookieService.get('usertoken'); // localStorage.getItem('userToken');
    let currentTime = new Date();
    let tokenStarttime = new Date(this.tokenstarttime);
    let tokenEnd = new Date(this.tokenendtime);
    if (!(currentTime > tokenStarttime && currentTime < tokenEnd) || (this.tokenstarttime === null && this.tokenendtime === null) || userToken === null) {
      // alert("token");
      forkJoin(
        this.authService.userAuthentication(UserName, password, 2000),
        //this.authService.clinicAuthentication(UserName, password, 2000),
        // this.authService.billingAuthentication(UserName, password, 2000),
      )//, res3
        .subscribe(([res1]: any) => {
          let coreToken = res1;
          LoginToken.coreAccessToken = coreToken.access_token;

          //let clinicToken = res2;
          //LoginToken.clinicAccessToken = clinicToken.access_token;

          //  let billingToken = res1;
          //  LoginToken.billingAcessToken = billingToken.access_token;
          window.ttoken = LoginToken.coreAccessToken;
          $('ttoken').val(LoginToken.coreAccessToken);
          $('#usertoken').val(LoginToken.coreAccessToken);
          $('#clinictoken').val(LoginToken.clinicAccessToken);
          sessionStorage.setItem('usertoken', LoginToken.coreAccessToken);
          sessionStorage.setItem('clinictoken', LoginToken.clinicAccessToken);
          //localStorage.setItem('billingToken', LoginToken.billingAcessToken);

          this.tokenstarttime = new Date();
          this.tokenendtime = new Date();
          this.tokenendtime.setTime(this.tokenstarttime.getTime() + (res1.expires_in * 1000));
          sessionStorage.setItem('TokenStartTime', this.tokenstarttime);
          sessionStorage.setItem('TokenEndTime', this.tokenendtime);
          this.cookieService.set('usertoken', LoginToken.coreAccessToken, this.tokenendtime, '/', null, false, "Strict");
          //this.cookieService.set('clinictoken', LoginToken.clinicAccessToken, this.tokenendtime, '/', null, false, "Strict");
          sessionStorage.setItem('ApplicationLockTime', res1.ApplicationLockTime)
          this.authService.loggedIn = true;
          this.app.username = res1.UserName;
          this.app.isLoggedIn$ = true;
          this.GetUsersDetailsById(UserName);
        },
          (err: HttpErrorResponse) => {
            this.processTheError(err)
            this.isloginError = true;
            this.islogin = false;
          });
    } else {

      //  if (sessionStorage.getItem("userId") != null && sessionStorage.getItem("userId") != undefined && sessionStorage.getItem("userId")!='')
      //    {
      this.authService.loggedIn = true;
      this.app.isLoggedIn$ = true;
      this.GetUsersDetailsById(UserName);
      //  }
      //  else
      //     this.toast.error("Another session may be already active.Please close this window");
    }
      }
    });
  }
  processTheError(errMessage: any) {
    if (errMessage != null && errMessage != undefined) {
      var errorBody = errMessage.error;
      var errorText = '';
      if (typeof errorBody === 'string') {
        errorText = errorBody;
      } else if (errorBody != null && errorBody.error_description != null) {
        errorText = errorBody.error_description;
      }

      if (errorText != '' && errorText.toLowerCase().includes('locked')) {
        this.toast.error("Your account is locked due to too many failed login attempts. Please contact your Administrator.");
        this.IsDisableSignIn = true;
      } else if (errorText != '') {
        this.toast.error(errorText);
      } else {
        this.toast.error("Invalid username or password.");
      }
    }
  }
  //****** Check user details By UserId after login validations Complete */
  GetUsersDetailsById(id: number) {
    this.authService.getUserDetailsById(id).subscribe(async (data: IUserDetails) => {
      this.userdetails = data;
      this.app.username = data.lastName + ',  ' + data.firstName;
      sessionStorage.removeItem("isdirect");
      sessionStorage.removeItem("directaddress");
      sessionStorage.setItem("isdirect", String(data.isdirect));
      sessionStorage.setItem("directaddress", String(data.directaddress));
      sessionStorage.setItem("userId", this.userdetails.userId.replace(/ /g, "+"));
      sessionStorage.setItem("username", this.app.username);
      sessionStorage.setItem("role", this.userdetails.roleName);
      sessionStorage.setItem("displayRoleName", this.userdetails.displayRoleName);
      sessionStorage.setItem("UserSessionID", this.userdetails.UserSessionId)
      //---loginuseridand role
      sessionStorage.setItem("loginUserId", this.userdetails.userId.replace(/ /g, "+"));
      sessionStorage.setItem("loginRole", this.userdetails.roleName);
      sessionStorage.setItem("isParentFacility", this.userdetails.isParentFacility == true ? '1' : '0');
      sessionStorage.setItem("UserIdentity", this.userdetails.userIdentity.toString());
      this.app.getUserLocations();
      this.getUserLocations1();
      await this.app.getmainMenuList();
      if (configuration.ISONCEnabled == true) {
        this.fngetEmergencyUser();
        this._userRoleservice.GetComponentRolePermissions();
      }
      //siva
      this.sharedService.GetSetUserConfiguration("", "PatientBoard_Settings", "Select").subscribe(res => {
        if (res)
          sessionStorage.setItem("PatientBoard_Fields", res.Values);
      });
      this.app.getcountTaskMessages();
      // alert(this.userdetails.roleName);
      this.app.username = sessionStorage.getItem("username");
      if (sessionStorage.getItem("role") === 'Admin' || sessionStorage.getItem("role") === "Clerk") {
        this.app.dproducts = this.app.dproducts.filter(a => a.Name !== 'Settings')
      } else {
        this.app.dproducts = this.app.dproducts;
      }
      this.clearLock();
      //this.fnGetComponentPermissions();

    },
      (err: HttpErrorResponse) => {
        this.islogin = false;
        this.isloginError = true;
      });
  }

  //*** clear lock  */
  clearLock() {
    this.lockService.deleteLockUsersInfo(sessionStorage.getItem("userId")).subscribe(data => {
    },
      (err: any) => console.log(err)
    );
  }
  fngetEmergencyUser() {
    sessionStorage.removeItem("EmergencyAccessEnabled");
    const inputData: any = {
      userid: encodeURIComponent(sessionStorage.getItem("userId")),
    };
    this._documentService.EmergencyUserPermissions(inputData, 'SELECTBYUSERID').subscribe(res => {
      if (res && res.length > 0) {
        sessionStorage.setItem("EmergencyAccessEnabled", "1")
      }
    });
  }
  //**** On Register button Click ,Nagivating Register component */

  onregister() {
    sessionStorage.setItem("isregister", 'true');
    this.router.navigateByUrl('/Register');
  }
  //***** Facility Dropdown change event method */
  facilityValue: number = 0;
  onfacilityselectionchange(event) {
    if (this.IsRegisterActivationLink == false) {
      sessionStorage.setItem('FacilityId', '0');
      this.facilityValue = event.value;
      this.IPAddressExists = true;
      this.activation.getFacilityByIPAddressByUserId(this.ClientIpAddress, "", event.value).subscribe((result: any) => {
        if (result == null) {
          this.IPAddressExists = true;
          this.IsDisableSignIn = true;
          this.IPAddressExists = false;
          this.CheckOTPExists = false;
        } else {
          if (result.toString().toLowerCase() == "notfound") {
            this.IPAddressExists = false;
            this.IsDisableSignIn = true;
            this.CheckOTPExists = false;

          } else {
            this.CheckOTPExists = false;
            this.IPAddressExists = true;
            this.IsDisableSignIn = false;
          }
        }
        // sessionStorage.setItem('FacilityId', event.value);

      })
    } else {
      //sessionStorage.setItem('FacilityId', event.value);
    }
    sessionStorage.setItem('FacilityId', event.value);

  }
  //*** Get All Locations Method*/
  public lstLocations: ILocationDetails[] = [];
  async getUserLocations1() {
    //if (this.IsRegisterActivationLink == true) {
    await this.sharedService.getLocationsByUser().subscribe(data => {
      this.lstLocations = data;
      sessionStorage.setItem('UserLocations', JSON.stringify(this.lstLocations));
      this.getLocationsByloginUser();
    });
    /// }
  }
  //*** Get All Locations  By UserId Method*/
  location: any;
  async getLocationsByloginUser() {
    await this.sharedService.getLocationsByLoginUser().subscribe(data => {
      this.location = Number(data);
      if (this.location == 0) {
        this.location = this.lstLocations[0].locationId;
      }
      sessionStorage.setItem("LocationId", this.location);
      if (sessionStorage.getItem("LocationId"))
        this.sharedService.getservercurrentdate().subscribe(result => {
          sessionStorage.setItem("PatBoardDate", new Date(result).toDateString());
          if (sessionStorage.getItem("role") == "Admin" || sessionStorage.getItem("role") == "Transcriptionist" || sessionStorage.getItem("role") == "Office Manager" || sessionStorage.getItem("role") == "Insurance") {
            setTimeout(() => {
              this.router.navigateByUrl('Appointments');
              //this.islogin = false;
            }, 500);
          }
          else if (sessionStorage.getItem("role") == "Doctor" || sessionStorage.getItem("role") == "Nurse Practitioner" || sessionStorage.getItem("role") == "Physician Assistant") {
            this.router.navigateByUrl('providerdashboard');
            //this.islogin = false;
          }
          else if (sessionStorage.getItem("role") == "Nurse" || sessionStorage.getItem("role") == "MA") {

            this.router.navigateByUrl('nursedashboard');
            // this.islogin = false;
          }
          else if (sessionStorage.getItem("role") == "Clerk") {
            this.router.navigateByUrl('clerkdashboard');
            // this.islogin = false;
          } else {
            this.router.navigateByUrl('Appointments');
            // this.islogin = false;
          }
        });
    });

  }
}
